// Shared catalogue invalidation is retained; the old shadow recommendations are gone.
export const RECOMMENDATIONS_CHANGED = 'uzdpart360:sourcing-data-saved';
export function publishSourcingChange(detail = {}) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(RECOMMENDATIONS_CHANGED, { detail }));
}
export const sourcingSaved = value => { publishSourcingChange(); return value; };
